module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("John Westwood began his career as an actor working in theatre, film, television and voice over. Musical theatre was his first introduction to performing and entertaining. Highlights for John were working with Petula Clark in London’s West End and Madonna in a music video. John is a fan of horror movies, especially Hammer horror films with the ultimate Dracula and John’s idol Sir Christopher Lee. Years later, he met his idol who became a friend. Another string to his bow! He is an award-winning country singer, and a screenwriter. When he is not writing, he relaxes by painting with acrylics or pastels.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0